import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { GroupBy } from '../_enums/groupby';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Ceu } from '../_models/ceu';
import { Combustible, DictionaryEntry } from '../_models/combustible';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CombustibleService {
  private headers!: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router
  ) {
    this.headers = this.authService.headers;
  }

  get(combustibleId: string) {
    return this.http.get<Combustible>(`${environment.apiUrl}/Carburants/${combustibleId}`, { headers: this.authService.headers });
  }

  getAll(groupBy?: string) {
    return this.http.get<DictionaryEntry<Combustible>[]>(`${environment.apiUrl}/Carburants?groupBy=${groupBy}`, { headers: this.authService.headers });
  }

  getCeu(resourceId?: string) {
    return this.http.get<Ceu>(`${environment.apiUrl}/Carburants/${resourceId}/CEU`, { headers: this.authService.headers });
  }

  update(combustible: Combustible) {
    combustible.environmentalData = undefined;
    return this.http.put<Combustible>(`${environment.apiUrl}/Carburants/${combustible.resourceId}`, combustible, { headers: this.authService.headers });
  }

  add(combustible: Combustible) {
    combustible.environmentalData = undefined;
    return this.http.post<Combustible>(`${environment.apiUrl}/Carburants`, combustible, { headers: this.authService.headers });
  }

  delete(resourceId: string) {
    return this.http.delete(`${environment.apiUrl}/Carburants/${resourceId}`, { headers: this.authService.headers });
  }

  duplicate(resourceId: string, code: string) {
    return this.http.post(`${environment.apiUrl}/Carburants/duplicate?id=${resourceId}&code=${encodeURIComponent(code)}`, null, { headers: this.authService.headers });
  }

  getDataSourceObservable(groupBy?: GroupBy) {
    return this.getAll(groupBy).pipe(map((comb) => comb?.flatMap((entry) => entry.value) ?? []));
  }

  getNavConfig({ perimeterId }: NavListCommonProps) {
    return {
      header: {
        title: 'ressource_list_title_combustibles',
        actions: [
          {
            label: 'ressource_list_action_create_combustible',
            onClick: () => {
              this.router.navigate([SiteMapUrl.MenuCombustible, 0], { state: { perimeterId } });
            }
          }
        ],
        filters: [
          { label: 'ressource_list_filter_by_family', value: GroupBy.family },
          { label: 'ressource_list_filter_by_favorite', value: GroupBy.favorite }
        ],
        defaultFilter: GroupBy.family
      },
      getDataSource: (groupBy?: GroupBy) => this.getDataSourceObservable(groupBy),
      getItemConfig: (node: Combustible) => ({
        displayName: `${node.displayName} [${node.code}]`,
        url: `${SiteMapUrl.MenuCombustible}/${node.resourceId}`,
        itemType: 'default',
        state: { currentItem: node, perimeterId }
      })
    };
  }
}
